module.exports = __webpack_public_path__ + "static/screenshot2-9751f71b1d09a75bba70aff93f5cb1dc.png";